import { gql } from '@apollo/client';

/**
 * The sequence's apnea screening sliced to one recording (project_management#555).
 * Separate from RECORDING_RPEAKS on purpose: it is null unless the apnea report
 * is enabled, and a failure here must never take the ECG chart down with it.
 */
export const RECORDING_APNEA = gql`
  query RecordingApnea($getMyRecordingId: MongoObjectID!) {
    getMyRecording(id: $getMyRecordingId) {
      id
      apneaScreening {
        sequenceId
        assessable
        windowDurationSec
        analysedMinutes
        apneaMinutes
        modelVersion
        minutes {
          startIndex
          endIndex
          probability
          partial
        }
      }
    }
  }
`;
